/**
 * A generic function to reduce down a list of options and process suppression.
 * @param {number} tab - The active tab.
 * @param {Map} labels - A Map containing slugs to labels.
 * @param {Array} options - Optional. List of options to map over. Defaults to the full list.
 * @returns {Array} An array of objects describing filters.
 */
const getOptions = (tab, labels, options) => options
  .filter(({ suppress }) => !suppress.includes(tab))
  .map(({ children, slug }) => ({
    children: getOptions(tab, labels, children),
    label: labels.get(slug),
    slug,
  }));

export default getOptions;
